import { fg } from '@atlaskit/platform-feature-flags/fg';
import { addSentryBreadcrumb } from '@atlassian/conversation-assistant-instrumentation/services/sentry';

import { initializeChatStore } from './initializeChatStore';
import { resetChatStoresForSite } from './resetChatStoresForSite';
import type { ChatStoreAction } from './types';

export const updateChatStoreSite =
	(): ChatStoreAction<Promise<void>> =>
	async ({ getState, setState, dispatch }, { siteId }) => {
		if (!fg('rovo_chat_site_switch_reset')) {
			return;
		}

		const { hydratedSiteId } = getState();

		if (!siteId || siteId === hydratedSiteId) {
			return;
		}

		await Promise.resolve();
		if (getState().hydratedSiteId === siteId) {
			return;
		}

		setState({ hydratedSiteId: siteId });

		if (hydratedSiteId === undefined) {
			return;
		}

		addSentryBreadcrumb('ChatStoreContainer: site changed, re-initialising chat');
		await dispatch(resetChatStoresForSite({ siteId }));
		await dispatch(initializeChatStore());
	};
